import { render, staticRenderFns } from "./FloatingActions.vue?vue&type=template&id=c3b3df60&scoped=true"
import script from "./FloatingActions.vue?vue&type=script&lang=js"
export * from "./FloatingActions.vue?vue&type=script&lang=js"
import style0 from "./FloatingActions.vue?vue&type=style&index=0&id=c3b3df60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b3df60",
  null
  
)

export default component.exports